import {
  Box,
  BoxProps,
  Button,
  Cards,
  ColumnLayout,
  Container,
  Grid,
  Icon,
  Pagination,
  Popover,
  PropertyFilter,
  TextFilter,
} from '@cloudscape-design/components';
import { Header } from '@cloudscape-design/components';
import { SpaceBetween } from '@cloudscape-design/components';
import { useMemo, useState } from 'react';
import { ReviewBasic, ReviewKeyword } from '../common/types';
import { ReviewContent } from './ReviewContent';
import { formatDateString } from '../common/formatting/dateFormat';
import { ReviewText } from './ReviewText';
import { ChatBubble, Avatar } from '@cloudscape-design/chat-components';
import { PropertyFilterQuery, useCollection } from '@cloudscape-design/collection-hooks';

export type KeywordListProps = {
  keywords: ReviewKeyword[];
  range: string;
  header?: React.ReactNode;
};

export const KEYWORD_COLOR_MAP: Record<ReviewKeyword['polarity'], BoxProps.Color> = {
  positive: 'text-status-success',
  negative: 'text-status-error',
  neutral: 'text-status-warning',
};

export type KeywordBlockProps = {
  keywords: ReviewKeyword[];
  header: React.ReactNode;
  range: string;
};

export function KeywordBlock(props: KeywordBlockProps) {
  const { keywords } = props;

  return (
    <Container fitHeight header={props.header}>
      <div className="flex flex-wrap gap-4 justify-center mb-4">
        {keywords.map((keyword) => (
          <Box key={keyword.keyword} variant="div">
            <Popover
              position="top"
              size="small"
              triggerType="text"
              header="Frequency"
              content={
                <Box variant="span" textAlign="center">
                  {/* TODO: use the range */}"{keyword.keyword}" appears{' '}
                  {keyword.count.toLocaleString()} times in the past {props.range}.
                </Box>
              }
            >
              <Box
                color={KEYWORD_COLOR_MAP[keyword.polarity]}
                variant="span"
                textAlign="center"
                fontSize="heading-l"
              >
                {keyword.keyword}
              </Box>
            </Popover>
          </Box>
        ))}
      </div>
    </Container>
  );
}

export function KeywordList(props: KeywordListProps) {
  const { keywords } = props;

  return (
    <SpaceBetween direction="vertical" size="l">
      {props.header}
      <ColumnLayout columns={2}>
        <KeywordBlock
          keywords={keywords.filter((keyword) => keyword.polarity === 'positive')}
          header={
            <Box variant="p" fontSize="heading-s" textAlign="center">
              <Icon name="thumbs-up" size="inherit" /> Positive Keywords
            </Box>
          }
          range={props.range}
        />
        <KeywordBlock
          keywords={keywords.filter((keyword) => keyword.polarity === 'negative')}
          header={
            <Box variant="p" fontSize="heading-s" textAlign="center">
              <Icon name="thumbs-down" size="inherit" /> Negative Keywords
            </Box>
          }
          range={props.range}
        />
      </ColumnLayout>
    </SpaceBetween>
  );
}
